import * as actionTypes from "./actionTypes";
import * as actions from './index';

export const updateMailingObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateMailingObjectsSuccess(obj));
    }
}

export const updateMailingObjectsStart = () => {
    return {
        type: actionTypes.MAILINGTOOL_UPDATE_MAILINGOBJECTS_START,
    }
}

export const updateMailingObjectsSuccess = (data) => {
    return {
        type: actionTypes.MAILINGTOOL_UPDATE_MAILINGOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateMailingObjectsFail = (error) => {
    return {
        type: actionTypes.MAILINGTOOL_UPDATE_MAILINGOBJECTS_FAIL,
        payload: error
    }
}

export const setMailingLoading = (data) => {
    return {
        type: actionTypes.MAILINGTOOL_SET_LOADING,
        payload: data
    }
}

export const sendPreviewMailObjects = ({ dataObj, formatMessage }) => {
    if (dataObj) {
        console.log("LAMTEST sendPreviewMailObjects dataObj", dataObj);
        return (dispatch) => {
            dispatch(actions.setMailingLoading(true));
            dispatch({ type: actionTypes.MAILINGTOOL_SEND_MAILINGOBJECTS });
            setTimeout(() => {
                window.flow
                    .crmSendPreviewNewsletter(dataObj)
                    .then(res => {
                        console.log("LAMTEST sendMailingObjects RES", res);
                        dispatch(actions.setMailingLoading(false));

                    }).catch(err => {
                        dispatch({ type: actionTypes.MAILINGTOOL_SEND_MAILINGOBJECTS_FAIL });
                        dispatch(actions.setMailingLoading(false));
                    })
                dispatch(actions.setMailingLoading(false));
            }, 1000);
        }
    }

}

export const sendMailObjects = ({ dataObj, formatMessage }) => {
    if (dataObj) {
        console.log("LAMTEST sendMailObjects dataObj", dataObj);
        return (dispatch) => {
            dispatch(actions.setMailingLoading(true));
            dispatch({ type: actionTypes.MAILINGTOOL_SEND_MAILINGOBJECTS });
            setTimeout(() => {
                window.flow
                    .crmSendNewsletter(dataObj)
                    .then(res => {
                        console.log("LAMTEST sendMailingObjects RES", res);

                    }).catch(err => {
                        dispatch({ type: actionTypes.MAILINGTOOL_SEND_MAILINGOBJECTS_FAIL });
                    })
                dispatch(actions.setMailingLoading(false));
            }, 1000);

        }
    }

}
